import { Flex, Heading } from '@chakra-ui/react';
import React from 'react';
import RulesTable from '../components/RulesTable';

const Reguli = () => {   
  return (
    <>
      <RulesTable />
    </>
  );
};

export default Reguli;
